import MainLayout from "@/components/layout/admin/MainLayout.vue";
import {
    required,
    maxLength
} from "vuelidate/lib/validators";
import axios from "axios";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "categoryUpdate",
    components: {
        MainLayout,
        Loading
    },

    data() {
        return {
            isLoading: false,
            fullPage: true,
            isEditForm: true,
            submitted: false,
            category_image: "",
            category: {
                category_name: ""
            }
        };
    },

    validations: {
        category: {
            category_name: {
                required,
                maxLength: maxLength(100)
            }
        }
    },

    methods: {
        onProfileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return null;
            this.category_image = e.target.files[0];
            let reader = new FileReader();
            reader.onload = e => {
                this.category_image = e.target.result;
                this.category.path = e.target.result;
            };
            reader.readAsDataURL(files[0]);
        },

        handleSubmit() {
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            this.updateCategory()
        },

        showCategoryUpdate() {
            axios.get("/category/update/" + this.$route.params.id)
                .then(response => {
                    this.category = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        updateCategory() {
            this.isLoading = true;
            var request;
            if (this.category_image.length < 10000000) {
                request = {
                    id: this.category.id,
                    category_name: this.category.category_name,
                    category_image: this.category_image,
                    old_category_image: this.category.category_image
                };
            } else {
                request = {
                    id: this.category.id,
                    category_name: this.category.category_name,
                    category_image: null,
                    old_category_image: null
                };
            }
            
            axios.post("/category/updated", request)
                .then(response => {
                    if (response.data.error_msg) {
                        this.image_size = response.data.msg;
                        this.isLoading = false;
                        this.$notification.error("The upload image size is too large.", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    } else {
                        this.$notification.success("Category Edited Successfully", {
                            timer: 3,
                            position: 'bottomCenter'
                        });
                        this.isLoading = false;
                        this.$router.push({
                            name: "categoryList"
                        });
                    }
                })
                .catch(error => {
                    this.isLoading = false;
                    this.$notification.error("Category Edit Failed", {
                        timer: 3,
                        position: 'bottomCenter'
                    });
                    console.log('Edit Category Error', error);
                });
        }
    },

    created() {
        this.showCategoryUpdate();
    }
};